module.exports = "<img\n  [class]=\"class\"\n  [alt]=\"alt\"\n  [defaultImage]=\"defaultImagePassed\"\n  [lazyLoad]=\"imagePassed\"\n  [offset]=\"offsetPassed\"\n>\n"


//////////////////
// WEBPACK FOOTER
// /Users/nicholasmurray/Documents/firebase-websites/CommunityAdviceNMD/src/app/components/lazy-image/lazy-image.component.html
// module id = ../../../../../src/app/components/lazy-image/lazy-image.component.html
// module chunks = main